<header role="banner">
  <div class="toolbar" fxLayout="row" fxLayoutAlign="space-between" style="height: 60px;">
    <div fxLayout="row" fxLayoutAlign="start center">
      <prep-toolbar-sidenav-mobile-toggle (openSidenav)="openSidenav.emit()"></prep-toolbar-sidenav-mobile-toggle>
      <img *ngIf="dynamicImgUrl" [src]="dynamicImgUrl" alt="Logo of {{logoAlttext}}" height="45"
        style="margin-right: 15px;" />
      <!-- Welcome message and roles -->
      <span class="prep-toolbar-user-head">
        {{LangTextData?.htmlLabel.welcome}} {{ account_user_name }}
        <span *ngIf="isOrganizationAdmin"
          aria-label="Organization Administrator">{{LangTextData?.htmlLabel.orgAdmin}}</span>
        <span *ngIf="!isSuperAdmin && isDepartmentAdmin"
          aria-label="Department Administrator">{{LangTextData?.htmlLabel.deptAdmin}}</span>
      </span>
      <span *ngIf="accountToconsole" style="margin-left: 10px;">
        <a href="https://stanford.prep.continualengine.com/" target="_blank" rel="noopener noreferrer"
          aria-label="Opens example website in a new tab" role="link" class="external-link"
          style="    color: rgb(19, 110, 248);text-decoration: underline;font-weight: bold;">
          {{accountConsoleLabel}}
        </a>

      </span>
      <!-- License expiry warning -->
      <p *ngIf="liccenseExpired" style="font-size: large;font-weight: bold;color: red;" role="alert"
        aria-live="assertive">
        {{LangTextData?.htmlLabel.licenseExpired}}
      </p>
    </div>
    <div fxLayout="row">
      <prep-toolbar-resources fxHide.xs *ngIf="prep_tool_enabled" class="toolbar-button"
        aria-label="PREP RESOURCES"></prep-toolbar-resources>
      <!-- Notifications -->
      <prep-toolbar-notifications *ngIf="router.url.includes('dashboard')" class="toolbar-button"
        aria-label="View notifications"></prep-toolbar-notifications>
      <!-- Help Button -->
      <span class="toolbar-button">
        <button #helpBtn class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" aria-label="Help"
          (click)="HelpClick()" [matTooltip]="LangTextData?.tooltipLabel.toolBoxHelp"
          matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
          <mat-icon aria-hidden="true">help_outline</mat-icon>
        </button>
      </span>
      <!-- Release Notes -->
      <prep-toolbar-release-notes fxHide.xs fxHide.sm class="toolbar-button"
        aria-label="View release notes"></prep-toolbar-release-notes>
      <!-- Fullscreen toggle -->
      <prep-toolbar-fullscreen-toggle fxHide.xs fxHide.sm class="toolbar-button"
        aria-label="Toggle fullscreen"></prep-toolbar-fullscreen-toggle>
      <!-- Search -->
      <prep-toolbar-search fxHide fxHide.xs fxHide.sm fxShow.gt-sm fxHide.gt-md class="toolbar-button"
        aria-label="Search"></prep-toolbar-search>
      <!-- User Profile Menu -->
      <prep-language-selector class="toolbar-button" aria-label="Language Selector"></prep-language-selector>
      <prep-toolbar-user fxHide.xs fxHide.sm class="toolbar-button"
        aria-label="User profile options"></prep-toolbar-user>
    </div>
  </div>
</header>